import { useGlobalStore } from '@highlight/ipc/react'
import { uuidV1Key, uuidV2Key } from '@shared/config/Config.ts'

export const useDeviceUUID = (version?: 'v1' | 'v2') => {
  const [deviceUUID] = useGlobalStore<string>('device', version !== 'v1' ? uuidV2Key : uuidV1Key)
  return deviceUUID ?? 'UNKNOWN'
}
